import '@babel/polyfill';

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/en';
import '@formatjs/intl-pluralrules/dist/locale-data/de';
import '@formatjs/intl-pluralrules/dist/locale-data/fr';
import '@formatjs/intl-pluralrules/dist/locale-data/nl';
import '@formatjs/intl-pluralrules/dist/locale-data/es';
import '@formatjs/intl-pluralrules/dist/locale-data/it';
import '@formatjs/intl-pluralrules/dist/locale-data/pt';
import '@formatjs/intl-pluralrules/dist/locale-data/zh';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';

import { MuiThemeProvider } from '@material-ui/core/styles';
import { create } from 'jss';
import { StylesProvider, createGenerateClassName, jssPreset } from '@material-ui/core/styles';

import { IntlProvider } from 'react-intl'; // test

import { LanguageProvider, LanguageConsumer } from './components/context/LanguageContext';
import { NotificationDialogProvider } from './components/context/NotificationDialogContext';
import { UserProvider, UserConsumer } from './components/context/UserContext';
import HelpdeskWidget from './components/content/HelpdeskWidget';

import flattenMessages from './utils/flattenMessages';
import { translations } from './intl/languages';

import App from './App';

import { customMuiTheme } from './customizedMuiTheme';

const generateClassName = createGenerateClassName();
const jss = create({
  ...jssPreset(),
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  insertionPoint: document.getElementById('jss-insertion-point'),
});

class AppContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BrowserRouter>
        <StylesProvider jss={jss} generateClassName={generateClassName}>
          <MuiThemeProvider theme={customMuiTheme}>
            <LanguageProvider>
              <LanguageConsumer>
                {({ language }) => (
                  <IntlProvider
                    locale={language}
                    messages={flattenMessages(translations[language])}
                  >
                    <UserProvider>
                      <UserConsumer>
                        {({ isLoggedIn, statsCookies, socialCookies, onCookiesChange }) => (
                          <HelpdeskWidget>
                            <NotificationDialogProvider>
                              <Route
                                path={['/:language/event/:id/', '/:language']}
                                render={props => (
                                  <App
                                    {...props}
                                    language={language}
                                    isLoggedIn={isLoggedIn}
                                    statsCookies={Boolean(statsCookies)}
                                    socialCookies={Boolean(socialCookies)}
                                    onCookiesChange={onCookiesChange}
                                  />
                                )}
                              />
                            </NotificationDialogProvider>
                          </HelpdeskWidget>
                        )}
                      </UserConsumer>
                    </UserProvider>
                  </IntlProvider>
                )}
              </LanguageConsumer>
            </LanguageProvider>
          </MuiThemeProvider>
        </StylesProvider>
      </BrowserRouter>
    );
  }
}

ReactDOM.render(<AppContainer />, document.getElementById('app'));
